import React, { useEffect, useState } from "react";
import api from "../../../../api";
import { Button, Table } from "antd";
import { useToast } from "../../../../components/toast/toast";
import { formatCurrency } from "../../../../utilities/utils";

const LotteryAwardTable = ({ lotteryId, activeKey }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast();

  const fetchData = async () => {
    setIsLoading(true);
    const res = await api.award_list(lotteryId);
    // console.log("award list --->", res);
    if (res.status === 200) {
      setData(res.data.data.draws);
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (activeKey === "2" && lotteryId) {
      fetchData();
    }
  }, [lotteryId, activeKey]);

  const deleteHandler = async (record) => {
    if (record?.id) {
      const res = await api.delete_award(record?.id);
      if (res.status === 200) {
        fetchData();
        toast("Амжилттай устгалаа", "success");
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
    } else {
      toast("ID шаардлагатай", "error");
    }
  };

  const columns = [
    {
      title: "Дугаар",
      dataIndex: "order_number",
      key: "order_number",
      width: 100,
    },
    {
      title: "Нэр",
      dataIndex: "prize_title",
      key: "prize_title",
    },
    {
      title: "Шагнал",
      dataIndex: "prize_amount",
      key: "prize_amount",
      render: (val) => formatCurrency(val) || "-",
    },
    {
      title: "Азын дугаар",
      dataIndex: "draw_number",
      key: "draw_number",
      render: (val) => val || "-",
    },
    {
      title: "Азтаны утас",
      dataIndex: "winner_info",
      key: "phone",
      render: (winner_info) => winner_info?.phone || "-",
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 120,
      render: (_, record) => (
        <Button
          type="link"
          style={{ fontSize: "12px", color: "#f00" }}
          onClick={() => deleteHandler(record)}
        >
          Устгах
        </Button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      rowKey="id"
      dataSource={data}
      loading={isLoading}
    />
  );
};

export default LotteryAwardTable;
